import { ASSET_BASE_URL, API_BASE_URL } from '../config/api';
import { isUsableCountryImageUrl } from './countryImages';

const DEFAULT_PUBLIC_ASSET_BASE = 'https://api.rcozzy.com';

export function resolveAssetUrl(path?: string | null): string | null {
  if (!path) return null;
  // Drop Nest `/static/` and Wikipedia before resolving — never hit the network.
  if (!isUsableCountryImageUrl(path)) return null;

  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  const base =
    ASSET_BASE_URL ||
    API_BASE_URL ||
    (import.meta.env.PROD ? DEFAULT_PUBLIC_ASSET_BASE : '');

  if (!base) return path.startsWith('/') ? path : `/${path}`;

  if (path.startsWith('/')) return `${base}${path}`;
  return `${base}/${path}`;
}
